import ButtonLink from './buttonLink.component';

export default ButtonLink;
